module.exports = __webpack_public_path__ + "static/img/i37.25ab091.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/i37.jpg
// module id = wjbX
// module chunks = 3